<template>
    <div class="ah-page bank-account-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>銀行帳戶設定</h1>
                    </div>
                    <div class="actions">
                        <el-button v-if="!isQR()" @click="handleAddBtnClick" type="highlight">新增銀行帳戶</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-header">
                    <div style="display: flex; padding: 20px; gap: 10px;">
                        <el-select v-model="queryParams.enableDocumentInUse" placeholder="帳戶狀態" @change="updateData" size="small">
                            <el-option :value="true" label="啟用中帳戶" />
                            <el-option :value="false" label="已停用帳戶" />
                        </el-select>
                        <el-select v-model="queryParams.typ" placeholder="帳戶類型" @change="updateData" size="small">
                            <el-option :value="null" label="全部類型" />
                            <el-option :value="0" label="存款戶" />
                            <el-option :value="1" label="暫存戶" />
                        </el-select>
                        <!-- <el-select v-model="queryParams.isBorrower" placeholder="借款戶" @change="updateData" size="small">
                            <el-option :value="null" label="不限" />
                            <el-option :value="true" label="借款戶" />
                            <el-option :value="false" label="非借款戶" />
                        </el-select> -->
                    </div>
                </div>
                <div class="panel-body">
                    <el-table-draggable handle=".handle" :animate="300" @drop="onChangeSort">
                        <el-table v-loading="isLoading" :data="datas" style="width: 100%" class="ah-el-data-table currency-table" empty-text="沒有資料">
                            <el-table-column width="45px" v-if="queryParams.typ === null">
                                <template slot-scope="">
                                    <div class="handle">
                                        <div v-for="i in 3" :key="i" />
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column type="index" label="#"></el-table-column>
                            <el-table-column prop="tpc" label="帳戶簡稱">
                                <template slot-scope="scope">
                                    <div class="strong">
                                        <span v-if="scope.row.isBorrower" class="borrow-label">
                                            借款戶
                                        </span>
                                        <span>{{ scope.row.tpc }}</span>
                                        <span class="ah-status danger" v-if="scope.row.wrN_FLG == 1 && !scope.row.isBorrower && scope.row.amt <= scope.row.wrN_AMT" style="margin-left: 5px"
                                            >餘額過低</span
                                        >
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="tpc" label="銀行 / 帳號">
                                <template slot-scope="scope">
                                    <template v-if="scope.row.bnK_BOO === '000' && scope.row.bnK_DOO === '000000'">
                                        <div>暫存戶</div>
                                    </template>
                                    <template v-else-if="!isLoanBank(scope.row)">
                                        <div>
                                            ({{ scope.row.bnK_BOO }})
                                            {{ scope.row.bnK_DOO_NAM }}
                                        </div>
                                        <div class="idx">
                                            {{ scope.row.bnK_ACC }}
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div>借款專戶</div>
                                    </template>
                                </template>
                            </el-table-column>
                            <el-table-column prop="bnK_NAM" label="存摺戶名"> </el-table-column>
                            <el-table-column prop="amt" label="目前餘額" align="right">
                                <template slot-scope="scope">
                                    <Money
                                        :v="scope.row.amt"
                                        :class="{
                                            lowWaring: scope.row.wrN_FLG == 1 && scope.row.amt <= scope.row.wrN_AMT
                                        }"
                                        :data-sno="scope.row.sno"
                                        :id="'bank-account-page-bank-' + scope.row.sno + '-amt'"
                                        :precision="scope.row.cny === 'TWD' ? null : 4"
                                    />
                                    <ahTip v-if="scope.row.cny != 'TWD'">
                                        <div>
                                            約當台幣：
                                            <Money :v="scope.row.amt * getCnyRat(scope.row.cny)" round />
                                        </div>
                                        <div style="opacity: 0.8; font-size: 10pt; margin-top: 5px">匯率：{{ getCnyRat(scope.row.cny) + " (即時)" }}</div>
                                    </ahTip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="cny" label="幣別" width="60" align="right"> </el-table-column>
                            <el-table-column label="" width="150">
                                <template slot-scope="scope">
                                    <el-tooltip v-if="!isQR()" style="margin-right: 10px" effect="dark" placement="top" content="此為系統借款專戶，請由「財務／借款管理」進行編輯" :manual="!isLoanBank(scope.row)">
                                        <span>
                                            <el-button size="small" :disabled="isLoanBank(scope.row)" @click="handleDataRowClick(scope.row)">
                                                編輯
                                            </el-button>
                                        </span>
                                    </el-tooltip>
                                    <el-button size="small" @click="handleDetailBtnClick(scope.row.sno)">明細</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-table-draggable>
                </div>
            </div>
        </div>
        <!-- <BankAccountDetailDialog ref="bankAccountDetailDialog" :onClose="handleDetailDialogClose" /> -->
    </div>
</template>
<script>
import _ from 'lodash';
import ElTableDraggable from 'element-ui-el-table-draggable';
// import BankAccountDetailDialog from './BankAccountDetailDialog.vue';

export default {
    name: 'BankAccount',
    components: {
        // BankAccountDetailDialog,
        ElTableDraggable,
    },
    data() {
        return {
            isLoading: false,
            datas: [],
            originalData: [],
            PageNum: 1,
            PageSize: 100,
            totalDataCount: 0,
            searchTxt: '',
            queryParams: {
                enableDocumentInUse: true,
                typ: null,
                isBorrower: null,
            },
        };
    },
    mounted() {
        this.updateData();
    },
    methods: {
        // 按下新增按鈕
        handleAddBtnClick() {
            this.$router.push({ name: 'bank-account-add' });
        },

        // 按下表格一行
        handleDataRowClick(data) {
            this.$router.push({
                name: 'bank-account-edit',
                params: { sno: data.sno },
            });
            // 改變網址
            // this.$router.push({ name: 'bank-account-detail', params: { sno: data.sno } })

            // 開啟詳細資料 dialog
            // this.$refs.bankAccountDetailDialog.show(data.sno)
        },

        // 關閉詳細資料後
        handleDetailDialogClose() {
            // 網址回復
            this.$router.push({ name: 'bank-account' });
        },

        // 分頁選單點選事件
        handlePaginationChange() {
            this.updateData();
        },

        // 更新客戶（顯示頁面時觸發）
        async updateData() {
            this.isLoading = true;
            this.errorMsg = '';

            // 開始取得資料
            const resp = await this.$api({
                // eslint-disable-next-line max-len
                url: `BankAccountSettingPage/GetSettings?PageNum=${this.PageNum}&PageSize=${this.PageSize}`,
                method: 'GET',
                params: this.queryParams,
            });
            // 取得成功
            this.isLoading = false;

            // 更新資料
            this.datas = resp.data.settings;
            this.originalData = [...this.datas];

            // 所有資料筆數
            this.totalDataCount = resp.data.totalNum;
        },

        handleDetailBtnClick(sno) {
            this.$router.push({
                name: 'bank-account-detail',
                query: { sno },
            });
        },
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        async onChangeSort() {
            const sorted = _.map(this.datas, (o, i) => ({
                sno: o.sno,
                sot: i,
            }));
            this.isLoading = true;
            try {
                await this.$api({
                    url: 'BankAccountSettingPage/UpdateSort',
                    method: 'POST',
                    data: { items: sorted },
                });
            } catch (e) {
                this.datas = [...this.originalData];
            } finally {
                this.isLoading = false;
            }
        },
        isLoanBank(row) {
            return !(row.bnK_BOO && row.bnK_DOO);
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.bank-account-page {
    .lowWaring {
        color: red;
    }

    .warning-label {
        color: red;
        display: inline-block;
        border: 1px solid red;
        border-radius: 5px;
        padding: 0px 10px;
        margin-right: 10px;
    }
    .borrow-label {
        background-color: #f95a7e;
        color: #fff;
        padding: 2px 5px;
        font-weight: bold;
        font-size: 9pt;
        border-radius: 5px;
        margin-right: 7px;
    }
    .handle {
        position: relative;
        width: 18px;
        height: 30px;
        margin: auto;
        > * {
            position: absolute;
            width: 100%;
            height: 2px;
            background-color: #ddd;
            transform: translateY(-50%);
        }
        :nth-child(1) {
            top: calc(50% + 5px);
        }
        :nth-child(2) {
            top: 50%;
        }
        :nth-child(3) {
            top: calc(50% - 5px);
        }
    }
}
</style>
